<template>
  <div class="flex">
    <div
      class="flex items-end col-span-2 md:col-auto row-start-2 md:row-start-1 md:items-center gap-1"
    >
      <Search
        :query="query"
        @searchChange="handleSearchChange($event?.target?.value || $event)"
      />
      <FilesFilters>
        <Filter />
      </FilesFilters>
    </div>

    <div
      class="col-start-2 md:col-start-auto row-start-1 flex flex-col-reverse items-end md:flex-row md:items-center gap-2 xl:gap-2"
    >
      <FilesUploadDialog>
        <Add :label="$t('admin.files.buttons.add')" />
      </FilesUploadDialog>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { Search } from "@/Components/Search";
import { Filter, Add } from "@/Components/Buttons";
import { useSearch } from "@/Composables/useSearch.js";
import FilesFilters from "@/Pages/Files/FilesFilters.vue";
import { FilesUploadDialog } from "@/SharedComponents/FilesUploadDialog";

const searchStore = useSearch("files");
const { query } = storeToRefs(searchStore);
const { handleSearchChange } = searchStore;
</script>
